import { useState, useContext, useEffect } from 'react'
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { DataProvider } from '../../../store/ContextProvider';
import { passwordValidator, confirmPasswordValidator, emailValidator } from '../../../utils/validator';
import { renderError } from '../../../components/renderError'


const SignUpEmployer = () => {

    const { BeURL, showAlert } = useContext(DataProvider)
    const [fullName, setFullName] = useState("")
    const [fullNameError, setFullNameError] = useState("")
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [emailError, setEmailError] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [passwordError, setPasswordError] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [confirmPasswordError, setConfirmPasswordError] = useState('')
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const [contact, setContact] = useState("")
    const [contactError, setContactError] = useState("")

    const [signupError, setSignupError] = useState('')

    const [loading, setLoading] = useState(false)

    const contentChecks = [email, password, fullName, confirmPassword,]
    const validationChecks = [emailError, passwordError, fullNameError, confirmPasswordError,]


    const HandleSignup = async (e) => {
        setLoading("")
        e.preventDefault()

        const payload = {
            fullName,
            email,
            password,
        };

        if (contact) {
            payload.contact = contact;
        }

        if (validationChecks.every(item => !Boolean(item)) && contentChecks.every(item => item !== "")) {
            setLoading(true)
            fetch(`${BeURL}/create-employer`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false)
                    if (data.success) {
                        showAlert(data.message)
                        setEmail('')
                        setPassword('')
                        setFullName('')
                        setContact('')
                        setConfirmPassword('')
                        setTimeout(() => {
                            window.location.href = "/list-users"
                        },[2000])
                    } else {
                        showAlert(data.message)
                        setSignupError(data.message)
                    }
                })
                .catch(err => {
                    setLoading(false)
                    alert('Trouble in connecting to the Server! Please try again later.')
                    console.log('Error in Singup:', err)
                })
        }

        if (!email) {
            setEmailError("Email is required!")
        }
        // if (!contact) {
        //     setContactError("Contact is required!")
        // }
        if (!password) {
            setPasswordError("Password is required!")
        }
        if (!fullName) {
            setFullNameError("First Name is Required!")
        }
        if (!confirmPassword) {
            setConfirmPasswordError("Confirm password is Required!")
        }
    }

    useEffect(() => {
        setEmailError(emailValidator(email))
        setPasswordError(passwordValidator(password))
        if (fullName !== "" && fullName.length < 3) {
            setFullNameError("Enter Atleast 3 Characters long!")
        }
        else setFullNameError("")
        setConfirmPasswordError(confirmPasswordValidator(password, confirmPassword))
        setSignupError("")

        if (contact !== "") {
            const contactRegex = /^[6-9][0-9]{9}$/;
            ;
            if (!contactRegex.test(contact)) {
                setContactError("Contact should be a valid 10 digit Number!")
            }
            else {
                setContactError("")
            }
        }
        else {
            setContactError("")
        }

    }, [email, password, fullName, confirmPassword, contact,])


    const handleContactSave = (e) => {
        setContact(e.target.value)
    }

    return (
        <div className='flex flex-wrap justify-center items-center min-h-[85vh]'>
            <div className='rounded-xl shadow-lg border border-slate-100 p-5 w-[96%] sm:w-8/12 md:w-2/6 my-3'>

                <span className='my-2 mx-auto w-max flex justify-center items-center p-2 rounded-full bg-secondary-500 text-white'>
                    <BsFillPersonPlusFill className='text-3xl' />
                </span>

                <h2 className='my-2 font-bold text-slate-800 text-center text-2xl'>Create Account</h2>
                <p className='my-2 text-slate-700 text-center'>Expand your recruiter network</p>

                <div className='my-2'>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='firstName'>Full Name</label>
                        <input value={fullName} onChange={e => setFullName(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400 h-full mt-2 px-2 py-1' type='text' id='fullName' placeholder='Enter your Full Name'></input>
                        {fullNameError && renderError(fullNameError)}
                    </div>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='contact'>Contact</label>
                        <input value={contact} onChange={handleContactSave} className='w-full rounded-lg placeholder:text-gray-400 h-full mt-2 px-2 py-1' type='tel' id='contact' placeholder='Enter your Contact Number (eg: 9876543210)'></input>
                        {contactError && renderError(contactError)}
                    </div>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='email'>Email Address</label>
                        <div className='flex gap-2 items-center mt-2'>
                            <input value={email} onChange={e => setEmail(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400 h-full px-2 py-1' type='email' id='email' placeholder='Enter your email'></input>
                        </div>
                        {emailError && renderError(emailError)}
                    </div>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='password'>Password</label>
                        <div className='mt-2 relative'>
                            <input value={password} onChange={e => setPassword(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400g pr-8 px-2 py-1 h-full' type={showPassword ? 'text' : 'password'} id='password' placeholder='Enter your password'></input>
                            {
                                showPassword ?
                                    <IoIosEyeOff className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowPassword(!showPassword)} /> :
                                    <IoIosEye className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowPassword(!showPassword)} />
                            }
                        </div>
                        {passwordError && renderError(passwordError)}
                    </div>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='confirmPassword'>Confirm Password</label>
                        <div className='mt-2 relative'>
                            <input value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400g pr-8 px-2 py-1 h-full' type={showConfirmPassword ? 'text' : 'password'} id='confirmPassword' placeholder='Re-Enter your password'></input>
                            {
                                showConfirmPassword ?
                                    <IoIosEyeOff className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowConfirmPassword(!showConfirmPassword)} /> :
                                    <IoIosEye className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
                            }
                        </div>
                        {confirmPasswordError && renderError(confirmPasswordError)}
                    </div>
                    {signupError && renderError(signupError)}
                    <button className={`w-full py-2 text-white bg-primary-400 rounded-lg my-2 ${loading ? 'cursor-progress' : ((validationChecks.some(item => item !== "") || contentChecks.some(item => item === "")) ? 'cursor-not-allowed' : 'cursor-pointer')}`} onClick={HandleSignup}>{loading ? 'Creating...' : 'Create'}</button>

                </div>
            </div>
        </div>
    )

}

export default SignUpEmployer